import React from 'react';

const SportspersonBottomline = () => {
  const benefits = [
    {
      title: "Career Longevity Planning",
      description: "Strategic financial management allows athletes to make career decisions based on long-term health and performance rather than short-term financial pressures, potentially extending earning years."
    },
    {
      title: "Lifestyle Continuity",
      description: "Proper planning creates financial structures that maintain lifestyle stability throughout career peaks, valleys, and during the critical transition to post-competitive life."
    },
    {
      title: "Brand Equity Optimization",
      description: "A comprehensive approach treats personal brand as a financial asset, strategically developing and monetizing it to generate income streams that extend beyond active competition years."
    },
    {
      title: "Legacy Protection",
      description: "Sophisticated wealth preservation strategies ensure that career achievements translate to lasting financial security and opportunities to leave meaningful impact through philanthropy."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Athletic Finance Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SportspersonBottomline;